import config from "../../config";
import $ from "jquery";
import { useState } from "react";
import "./style.css";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import expenseCategorySchema from "../../validations/expenseCategorySchema";

function ExpenseCategoryAdd(props) {
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const id = props.id;
  const [selectedcode, setSelectedCode] = useState("");
  const[ createBtn,setCreateBtn]=useState(false)

  const handlecodeChange = (selectedcode) => {
    setSelectedCode(selectedcode);
  };

 

  const expenseCategoryFormik = useFormik({
    initialValues: {
      exp_cat_name: "",
      exp_cat_type: "",
    },
    validationSchema: expenseCategorySchema.validateExpCatAdd(),
    validateOnChange: false,
    validateOnBlur: false,

    onSubmit: async (values) => {
      setIsSubmit(true);
      await $.post(
        `${config.apiUrl}/expCategory/createExpCategory`,
        JSON.stringify(values)
      )
        .done(function (res) {
          setSuccess(res.message);
          setCreateBtn(true);
          setError("");
          props.list();
        })
        .catch(function (err) {
          setError(err.responseJSON.data?.message || err.responseJSON.message);
          setSuccess("");
        })
        .always(function () {
          setIsSubmit(false);
        });
    },
  });
  return (
    <>
    <Modal.Header closeButton><h4 style={{ marginLeft: "10rem", height: "4px" }} id="modalhead">Add Expense Category</h4></Modal.Header>
      <div className="container-fluid p-4" id="expcatAdd">
        <form className="row g-3" onSubmit={expenseCategoryFormik.handleSubmit} autoComplete="off">
          <div className="col-md-6">
            <label htmlFor="exp_cat_name">
              Expense Category Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="exp_cat_name"
              maxLength={50}
          
              {...expenseCategoryFormik.getFieldProps("exp_cat_name")}
            />
            {expenseCategoryFormik.errors.exp_cat_name ? (
              <div className="text-danger small">
                {expenseCategoryFormik.errors.exp_cat_name}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="exp_cat_type">
              Expense Category Type <span className="text-danger">*</span>
            </label>
            <select
            type="text"
              className="form-select"
              id="exp_cat_type"
              {...expenseCategoryFormik.getFieldProps("exp_cat_type")}>
              <option value="" hidden>Select...</option>
              {config.expenseCategories
                .filter((item) => [1, 2].includes(item.value))
                .map((list) => (
                  <option key={list.value} value={list.value}>
                    {list.label}
                  </option>
                ))}
            </select>
            {expenseCategoryFormik.errors.exp_cat_type ? (
              <div className="text-danger small">
                {expenseCategoryFormik.errors.exp_cat_type}
              </div>
            ) : null}    
          </div>
          <div className="col-12 mt-4">
            {(error || success) && (
              <div
                className={`alert alert-${
                  error ? "danger" : "success"
                } py-2 small`}
                role="alert"
              >
                {error || success || ""}
              </div>
            )}

            <div style={{ float: "right" }}>
            <button
            type="button"
              className="expcatModalCancel"
              onClick={props.hide}
            >
              Cancel
            </button>
              {createBtn ? (
                <button 
                onClick={()=>{
                  setSelectedCode(null)
                  expenseCategoryFormik.resetForm()
                  setCreateBtn(false)
                  setSuccess("")
                }}
               id="createNew" 
              // className="btn btn-primary"
              type="button"
              >
              Add New
              </button>):   (<button type="submit" disabled={isSubmit}>
              {isSubmit && (
                <span className="spinner-border spinner-border-sm me-2"></span>
              )}
              Save
            </button>)}
            
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default ExpenseCategoryAdd;
